import React from 'react';

import ApplePodcast from '@components/Images/ApplePodcast';
import IconX from '@components/Images/Rebranding/IconX';
import Spotify from '@components/Images/Spotify';
import Youtube from '@components/Images/Youtube';

export const AWS_LOGO = 'AWS Logo';
export const AWS_TRACKING_LINK =
  'https://aws.amazon.com/executive-insights/generative-ai-ml/?trk=c5701c52-0cd1-44e0-8617-a6996be1697a&sc_channel=display+ads';
export const THE_INFORMATION_AM = 'The Information AM';
export const SEE_ALL_NEWSLETTERS_TEXT = 'See all newsletters';
export const EXPLORE_OUR_NEWSLETTERS_TEXT = 'Explore our newsletters';

export const STREAM_CHANNELS_PATHS = [
  {
    name: 'YouTube',
    url: 'https://youtube.com/@theinformation',
    icon: (
      <Youtube
        className="fill-primary-magenta transition group-hover:fill-primary-pink"
        height={28}
        viewBox="0 0 48 34"
        width={40}
      />
    ),
  },
  {
    name: 'Spotify',
    url: ' https://open.spotify.com/show/26rhICriZ8V54HMh9lIOxh?si=97e65f9d7cde4481',
    icon: (
      <Spotify
        className="text-primary-magenta transition group-hover:text-primary-pink"
        height={37}
        viewBox="0 0 37 37"
        width={37}
      />
    ),
  },
  {
    name: 'Apple Podcast',
    url: 'https://podcasts.apple.com/us/podcast/the-informations-411/id1035041995',
    icon: (
      <ApplePodcast
        className="text-primary-magenta transition group-hover:text-primary-pink dark:[&>path:not(:first-child)]:fill-black"
        height={35}
        viewBox="0 0 38 38"
        width={35}
      />
    ),
  },
  {
    name: 'X',
    url: 'https://x.com/theinformation',
    icon: (
      <IconX
        className="text-primary-magenta transition group-hover:text-primary-pink"
        height={32}
        width={32}
      />
    ),
  },
];
